import { useEffect } from 'react';

/**
 * Custom hook to dynamically update document title and meta description for SEO.
 * @param {string} title - The page title (recommended length: 50-60 characters).
 * @param {string} description - The meta description (recommended length: 150-160 characters).
 */
export default function useDocumentMetadata(title, description) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    if (description) {
      // Find or create the meta description tag
      let metaDescription = document.querySelector('meta[name="description"]');
      if (!metaDescription) {
        metaDescription = document.createElement('meta');
        metaDescription.setAttribute('name', 'description');
        document.head.appendChild(metaDescription);
      }
      metaDescription.setAttribute('content', description);
    }
  }, [title, description]);
}
